import { defineRouteMiddleware, navigateTo } from '@/shared/utils/router.js';
import { useAuthStore } from '#modules/auth/stores/auth.store.js';

export default defineRouteMiddleware(function ensureUserIsVerified(to) {
    const authStore = useAuthStore();

    if (to.name !== 'settings' && !authStore.isVerified) {
        return navigateTo({
            name: 'settings',
        });
    }
});
